var estimate = {
    Width: 50,
    Height: 25,
    Quantity: 100,
    Substrate: 'UncoatedPaper',
    Laminate: 'NoLamination',
    LabelsPerCore: null,
    Cost: 0,
    DesignMethod: null,  // "upload" or "brief"
    UploadedFile: null,  // Main PDF file for direct upload
    BriefAnswers: [],    // Text answers
    BriefFiles: {}       // Files for brief, organized by question
}

var lastEstimateRequest = null;

// Initialize with initial estimate
getEstimate();

// Core estimation functions
function getEstimate() {
    // Log the request instead of making API call
    let request = { 
        Width: estimate.Width, 
        Height: estimate.Height, 
        Quantity: estimate.Quantity, 
        Substrate: estimate.Substrate, 
        Laminate: estimate.Laminate, 
        LabelsPerCore: estimate.LabelsPerCore 
    }

    if(lastEstimateRequest == request){
        return;
    }

    lastEstimateRequest = request;
    
    $.ajax({
        type: "POST",
        contentType: 'application/json',
        // url: 'https://localhost:7027/api/Estimate',
        url: 'https://uyrone-ulabels-orders.azurewebsites.net/api/Estimate',
        data: JSON.stringify({ 
            width: estimate.Width, 
            height: estimate.Height, 
            quantity: estimate.Quantity, 
            substrate: estimate.Substrate, 
            laminate: estimate.Laminate, 
            labelsPerCore: estimate.LabelsPerCore 
        }),
        success: function (response) {
            updateEstimateCost(response.totalCost);
            console.log(response.Estimate);
        },
        dataType: 'json'
    });
}


function updateEstimateCost(totalCost) {
    estimate.Cost = totalCost;
    $('.estimate-total').html((Math.round(estimate.Cost * 100) / 100).toFixed(2));
}

// Input handling
function inputUpdate(input) {
    var newVal = $(input).val();
    const field = $(input).attr('data-map');
    
    // Validate inputs
    if (field === 'Width' && parseInt(newVal) > 290) {
        estimate.Width = 290;
        $(input).val(290);
        newVal = 290;
    } else if (field === 'Height' && parseInt(newVal) > 600) {
        estimate.Height = 600;
        $(input).val(600);
        newVal = 600;
    }
    
    // Update estimate if value is valid
    if (newVal.length > 0) {
        estimate[field] = newVal;
        getEstimate();
    }
}

// Refined animation handlers
function showUploadSection() {
    // Fade out the options
    $('#design-options').addClass('fade-transition').css('opacity', 0);
    
    // After fade out, hide options and show upload section
    setTimeout(function() {
        $('#design-options').hide();
        $('#upload-section').addClass('slide-transition').show();
        
        // Trigger reflow before adding show class for animation
        $('#upload-section')[0].offsetHeight;
        $('#upload-section').addClass('show');
    }, 300);
}

function showBriefSection() {
    // Fade out the options
    $('#design-options').addClass('fade-transition').css('opacity', 0);
    
    // After fade out, hide options and show brief section
    setTimeout(function() {
        $('#design-options').hide();
        $('#brief-section').addClass('slide-transition').show();
        
        // Trigger reflow before adding show class for animation
        $('#brief-section')[0].offsetHeight;
        $('#brief-section').addClass('show');
    }, 300);
}

function resetDesignChoice() {
    // Reset data
    estimate.UploadedFile = null;
    estimate.DesignMethod = null;
    estimate.BriefAnswers = [];
    estimate.BriefFiles = {};
    
    // Reset UI forms
    $('.file-drop-area').removeClass('file-uploaded dragover');
    $('#upload-status').text('').removeClass('error success').hide();
    $('#pdf-upload').val('');
    $('.brief-question-answer').val('');
    $('.upload-preview-area').empty();
    
    // Hide the buy now button with fade
    $('.buy-now-container').addClass('fade-transition').css('opacity', 0);
    setTimeout(function() {
        $('.buy-now-container').hide();
    }, 300);
    
    // Smoothly transition sections
    $('.design-section').removeClass('show');
    
    // After transition completes, hide sections and show options
    setTimeout(function() {
        $('.design-section').hide();
        $('#design-options').show();
        
        // Trigger reflow before fade in
        $('#design-options')[0].offsetHeight;
        $('#design-options').css('opacity', 1);
    }, 300);
}

// File handling functions
function handleFileUpload(file) {
    if (!file) return;
    
    // Validate file type
    if (file.type !== 'application/pdf') {
        $('#upload-status').text('Please upload a PDF file').addClass('error').show();
        return;
    }
    
    // Store and update UI
    estimate.UploadedFile = file;
    estimate.DesignMethod = 'upload';
    $('#upload-status').text(`File "${file.name}" uploaded successfully`).removeClass('error').addClass('success').show();
    $('.file-drop-area').addClass('file-uploaded');
    
    // Show buy now button with fade in
    $('.buy-now-container').show();
    $('.buy-now-container').addClass('fade-transition');
    
    // Trigger reflow before setting opacity
    $('.buy-now-container')[0].offsetHeight;
    $('.buy-now-container').css('opacity', 1);
    
    console.log("File uploaded:", file.name);
}

function handleBriefFileUpload(input) {
    const files = input.files;
    if (!files || files.length === 0) return;
    
    const questionId = $(input).attr('id');
    const question = $(input).data('question');
    const previewAreaId = questionId.replace('brief-upload-', 'preview-area-');
    
    // Initialize files array if needed
    if (!estimate.BriefFiles[questionId]) {
        estimate.BriefFiles[questionId] = [];
    }
    
    // Process each uploaded file
    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        estimate.BriefFiles[questionId].push(file);
        
        // Create and add preview element
        const preview = createFilePreview(file, questionId);
        $(`#${previewAreaId}`).append(preview);
    }
    
    console.log(`Files added to question "${question}":`, files);
    updateBriefValidation();
}

// New function to check brief content and show/hide buttons
function updateBriefValidation() {
    let hasTextAnswer = false;
    let errorMessage = "";
    
    // Check text answers only
    $('.brief-question-answer').each(function() {
        if ($(this).val().trim()) {
            hasTextAnswer = true;
        }
    });
    
    if (!hasTextAnswer) {
        errorMessage = "Please provide at least one answer to continue.";
    }
    
    // Update UI
    if (errorMessage) {
        $('#brief-validation-message').text(errorMessage).show();
        $('.buy-now-container').hide();
    } else {
        $('#brief-validation-message').hide();
        collectBriefAnswers();
        $('.buy-now-container').show().css('opacity', 1);
    }
}

function createFilePreview(file, questionId) {
    const previewContainer = $('<div class="file-preview-item"></div>');
    const fileInfo = $(`<div class="file-info"><span class="file-name">${file.name}</span> (${formatFileSize(file.size)})</div>`);
    const removeBtn = $('<button class="remove-file-btn"><i class="fa-solid fa-xmark"></i></button>');
    
    // Create preview based on file type
    if (file.type.match('image.*')) {
        const reader = new FileReader();
        reader.onload = function(e) {
            const img = $('<img class="file-thumbnail">').attr('src', e.target.result);
            previewContainer.prepend(img);
        }
        reader.readAsDataURL(file);
    } else {
        // For non-images (like PDFs)
        const icon = $('<div class="file-icon"><i class="fa-solid fa-file-pdf"></i></div>');
        previewContainer.prepend(icon);
    }
    
    // Handle file removal
    removeBtn.click(function() {
        const fileIndex = estimate.BriefFiles[questionId].findIndex(f => 
            f.name === file.name && f.size === file.size);
            
        if (fileIndex > -1) {
            estimate.BriefFiles[questionId].splice(fileIndex, 1);
        }
        
        previewContainer.remove();
        console.log(`File removed from question ${questionId}:`, file.name);
    });
    
    previewContainer.append(fileInfo, removeBtn);
    return previewContainer;
}

function formatFileSize(bytes) {
    if (bytes < 1024) return bytes + ' bytes';
    else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
    else return (bytes / 1048576).toFixed(1) + ' MB';
}

// Brief submission
function collectBriefAnswers() {
    estimate.BriefAnswers = [];
    estimate.DesignMethod = 'brief';
    
    // Collect text answers
    $('.brief-question-answer').each(function() {
        const answer = $(this).val().trim();
        if (answer) {
            estimate.BriefAnswers.push({
                question: $(this).data('question'),
                type: $(this).data('type'),
                answer: answer
            });
        }
    });
    
    // Log the brief data
    console.log("Brief Answers:", estimate.BriefAnswers);
    console.log("Brief Files:", estimate.BriefFiles);
}

// Checkout process
function checkout() {
    // Show spinner
    $('.button-spinner').show();
    $('.action-checkout').prop('disabled', true);

    // If it's a brief submission, collect answers again to ensure we have the latest
    if (estimate.DesignMethod === 'brief') {
        collectBriefAnswers();
    }

    const formData = new FormData();
    
    // Add basic estimate data
    formData.append('width', estimate.Width);
    formData.append('height', estimate.Height);
    formData.append('quantity', estimate.Quantity);
    formData.append('substrate', estimate.Substrate);
    formData.append('laminate', estimate.Laminate);
    formData.append('labelsPerCore', estimate.LabelsPerCore);
    formData.append('designMethod', estimate.DesignMethod);

  // Handle file upload method
    if (estimate.DesignMethod === 'upload' && estimate.UploadedFile) {
        formData.append('uploadedFile', estimate.UploadedFile);
    }

    // Handle brief method
    if (estimate.DesignMethod === 'brief') {
        // Prepare briefAnswers array with both text answers and file references
        let allBriefAnswers = [...estimate.BriefAnswers];
        
        // Add brief files
        for (const [questionId, files] of Object.entries(estimate.BriefFiles)) {
            // Get the actual question text from the corresponding input element
            const questionText = $(`#${questionId}`).data('question');
            
            files.forEach(file => {
                // Append each file with a simple key name 'files'
                formData.append('files', file);
                
                // Add a file reference to the overall answers using the actual question text
                allBriefAnswers.push({
                    question: questionText,
                    type: 'file',
                    answer: file.name
                });
            });
        }

        // Add a new question 'Details' where we put the width, height (mm), quantity, substrate and laminate
        allBriefAnswers.push({
            question: 'Details',
            type: 'text',
            answer: `Width: ${estimate.Width}mm, Height: ${estimate.Height}mm, Quantity: ${estimate.Quantity}, Substrate: ${estimate.Substrate}, Laminate: ${estimate.Laminate}`
        });

        // Add all brief answers at once
        if (allBriefAnswers.length > 0) {
            formData.append('briefAnswers', JSON.stringify(allBriefAnswers));
        }
    }

    // Make API call
    $.ajax({
        type: "POST",
        // url: 'https://localhost:7027/api/CreateProduct/create-product',
        url: 'https://uyrone-ulabels-orders.azurewebsites.net/api/CreateProduct/create-product',
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
            console.log("Product created:", response);
            if (response.variantId) {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: response.variantId.replace('gid://shopify/ProductVariant/',''),
                        quantity: 1,
                        properties: {
                            'proof-id': response.guid  // Add the reference as a line item property
                        }
                    })
                })
                .then(response => response.json())
                .then(data => {
                    console.log("Item added:", data);
                    updateCart();
                })
                .catch(error => {
                    console.error("Error adding to cart:", error);
                    hideSpinner();
                    alert("Error adding to cart. Please try again.");
                });
            }
        },
        error: function(xhr, status, error) {
            console.error("Error creating product:", error);
            hideSpinner();
            alert("Error creating product. Please try again.");
        }
    });
}

function hideSpinner() {
    $('.button-spinner').hide();
    $('.action-checkout').prop('disabled', false);
}

function updateCart() {
    document.location = '/cart'
    //fetch('/cart.js')
    //    .then(response => response.json())
    //    .then(cart => {
    //        console.log('Updated cart:', cart);
    //        // Update cart UI here
    //    });
}

// Event handlers
$(document).ready(function () {
    // Checkout button
    $('.action-checkout').click(checkout);
    
    // Material and laminate selection
    $('select.estimate-input').change(function () {
        estimate[$(this).attr('data-map')] = $(this).val();
        getEstimate();
    });
    
    // Dimension and quantity input
    $('input.estimate-input').keyup(function () {
        inputUpdate(this);
    });
    
    // Upload design flow
    $('#upload-design-btn').click(showUploadSection);
    $('#browse-files-btn').click(function() {
        $('#pdf-upload').click();
    });
    $('#pdf-upload').change(function(e) {
        handleFileUpload(e.target.files[0]);
    });
    
    // File drop area
    const dropArea = $('.file-drop-area');
    dropArea.on('dragover', function(e) {
        e.preventDefault();
        dropArea.addClass('dragover');
    });
    dropArea.on('dragleave', function() {
        dropArea.removeClass('dragover');
    });
    dropArea.on('drop', function(e) {
        e.preventDefault();
        dropArea.removeClass('dragover');
        
        if (e.originalEvent.dataTransfer.files.length) {
            handleFileUpload(e.originalEvent.dataTransfer.files[0]);
        }
    });
    
    // Brief design flow
    $('#request-design-btn').click(showBriefSection);
    $(document).on('change', '.brief-file-input', function() {
        handleBriefFileUpload(this);
        updateBriefValidation();
    });
    $('.brief-question-answer').on('input', updateBriefValidation);
    $('#submit-brief').remove();
    
    // Reset functionality
    $('#reset-upload, #reset-brief').click(resetDesignChoice);
    
    // Initialize animation classes
    $('.design-section').addClass('slide-transition');
    $('.buy-now-container').addClass('fade-transition');
    
    // Make sure sections are initially hidden
    $('.design-section, .buy-now-container').hide();
});